import { lg } from '~/modules/colorLog';
import { EventEmitter } from '@angular/core';

export const sportsTypesChangeListener: EventEmitter<any> = new EventEmitter();

let sport_type_data = [];

export let SPORTS_TYPE = () => {
    return sport_type_data;
};

export const DATA_INITIALIZER = _SPORT_DATA =>
    new Promise(done => {
        //lg('INIT', 'SPORT CONSTANT OKAY..');
        sport_type_data = _SPORT_DATA;
        // console.log('sport_type_data---sport_type_data--SSSSSSS', sport_type_data);
        sportsTypesChangeListener.emit(_SPORT_DATA);
        done();
    });
